const BRAND_CURATION_STATUS_FILTER = {
  CURATION_DONE: {
    label: 'Curation Done',
    value: 'CURATION_DONE',
  },
  QA_DONE: {
    label: 'Qa Done',
    value: 'QA_DONE',
  },
  QC_DONE: {
    label: 'Qc Done',
    value: 'QC_DONE',
  },
}

export default BRAND_CURATION_STATUS_FILTER
